import React from "react";
import {Button} from "@mui/material";
import {CallbackHandler} from "@lxo-blocks/react";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import {useLxTranslations} from "@lxo-blocks/react";
import {METHODS_VIEW_TRANSLATION} from "../MethodsView.translation.de";

export interface ChangeMethodButtonProps {
    onChangeMethod: CallbackHandler,
}

export default function ChangeMethodButton(props: ChangeMethodButtonProps) {
    const {t} = useLxTranslations(METHODS_VIEW_TRANSLATION);

    return (
        <>
            <Button color="secondary" onClick={() => props.onChangeMethod()}>{t("METHOD_CHANGE_BTN")}<SwapHorizIcon sx={{pl: 1}}/></Button>
        </>
    );
}
